export default __webpack_public_path__ + "static/media/01d.6e4f36b6.png";